<template>
    <div class="ti">
      <div class="cdj_ti">
        <div style="margin-top: 10px;margin-left: 20px;">
            <span class="cdj_span">当前位置：<span class="cdj_text">我的应用</span></span>
        </div>
        <div class="cdj_margin">
            <!-- 权限10101 -->
            <div @click="apps('Repair')" v-if="userJid[0]['id']==10101">
                <el-card class="box-card">
                    <div class="text item">
                        <!-- <img src="http://www.dadesa.com:8080/static/img/报修.png"> -->
                        <img :src="imgurl">
                        <span class="cdj_text1">报事报修</span>
                    </div>
                </el-card>
            </div>
            <!-- 权限10102 -->
            <div class="cdj_weiz"></div>
            <div @click="apps('Complaint')" v-if="userJid[1]['id']==10102">
                <el-card class="box-card">
                    <div class="text item">
                        <!-- <img src="http://www.dadesa.com:8080/static/img/投诉建议.png"> -->
                        <img :src="imgurl1">
                        <span class="cdj_text1">投诉建议</span>
                    </div>
                </el-card>
            </div>
            <!-- 权限10103 -->
            <div class="cdj_weiz"></div>
            <div @click="apps('Consult')" v-if="userJid[1]['id']==10102">
                <el-card class="box-card">
                    <div class="text item">
                        <img :src="imgurl1">
                        <span class="cdj_text1">咨询管理</span>
                    </div>
                </el-card>
            </div>
            <!-- 舆情 -->
            <div class="cdj_weiz"></div>
            <div @click="apps('Conversation')" v-if="userJid[2]['id']==10103">
                <el-card class="box-card">
                    <div class="text item">
                        <img :src="imgurl1">
                        <span class="cdj_text1">舆情会话</span>
                    </div>
                </el-card>
            </div>
            <!-- 名贴 -->
            <div class="cdj_weiz"></div>
            <div @click="apps('Card')" v-if="userJid[3]['id']==10104">
                <el-card class="box-card">
                    <div class="text item">
                        <img :src="imgurl1">
                        <span class="cdj_text1">名贴</span>
                    </div>
                </el-card>
            </div>
        </div>
      </div>
    </div>
</template>

<script>
import imgurl from "../../../assets/js/imgurl.js"
export default {
  name: 'AppIndex',
  data () {
    return {
        imgurl:'',
        imgurl1:'',
        userJid:[]
    }
  },
  //界面没出来前加载
  created() {
    this.imgurl = imgurl+"/static/img/报修.png";
    this.imgurl1 = imgurl+"/static/img/投诉建议.png";
    this.userJid = [{id:''},{id:''},{id:''},{id:''}];
    this.$myhttp.get('admin/lavel3?pid=10',{
      'Content-Type': 'application/json'
      }).then(backdata=>{ // 异步执行成功后
        if(backdata.data != 1){
          var date = backdata.data;
          date.forEach(item => {
            //本界面权限
            if(item.id == 10101){
              this.userJid[0]['id'] = item.id;
            }
            if(item.id == 10102){
              this.userJid[1]['id'] = item.id;
            }
            if(item.id == 10103){
              this.userJid[2]['id'] = item.id;
            }
            if(item.id == 10104){
              this.userJid[2]['id'] = item.id;
            }
          });
        }else{
          //本界面权限
          this.userJid = [{id:'10101'},{id:'10102'},{id:'10103'},{id:'10104'}];
        }
      });
  },
  // 加载数据
  mounted(){

  },
  //事件
  methods: {
    apps(url){
        this.$router.push(url);
    }
  },
}
</script>
<style scoped>
.cdj_weiz{
    width: 20px;
}
.ti{
    margin: 0 10px;
    padding-top: 10px;
    width: 98.6%;
}
.zhohang{
  width: 50%;
}
.texts{
    color: rgb(240, 236, 236);
}
.cdj_span{
    padding-left:10px;
    border-left: 2px solid rgb(24, 90, 233);
}
.cdj_text{
    color: rgb(24, 90, 233);
}
.cdj_ti{
    margin-top:10px;
    width:100%;
    /*height:100%;*/
    background-color:white;
    overflow: scroll;
}
.text {
    font-size: 13px;
}
.item img{
    width: 40px;
    height:40px;
}
.box-card {
    margin-top:20px;
    width: 200px;
    height: 80px;
}
.cdj_margin{
    display:flex;
    flex-wrap:wrap;
    margin-left:20px;
}
.cdj_text1{
    position:absolute;
    margin-left:8px;
    margin-top:1px;
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/App/Index.vue